/**
 * ModuleTriggerType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleTriggerType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleTriggerType {
  GENERIC     = 0,
  TRANSITION  = 1,
  TRAP        = 2,
}